import { AuthResponse, ForgetPasswordInput, InitiateLoginInput, LoginInput, RegisterInput, ResetPasswordInput, VerifyForgetPasswordTokenInput } from '../types';
import { API_ENDPOINTS } from './api-endpoints';
import { HttpClient } from './http-client';

export const userClient = {
  initiateLogin: (data: InitiateLoginInput) => {
    return HttpClient.post<AuthResponse>(API_ENDPOINTS.CUSTOMER_LOGIN, data);
  },
  login: (variables: LoginInput) => {
    return HttpClient.post<AuthResponse>(API_ENDPOINTS.LOGIN, variables);
  },
  refreshToken : (variables: any, header?: any) => {
    return HttpClient.post<AuthResponse>(API_ENDPOINTS.REFRESH_TOKEN, variables,header);
  },
  // logout: () => {
  //   return HttpClient.post<any>(API_ENDPOINTS.LOGOUT, {});
  // },
  register: (variables: RegisterInput) => {
    return HttpClient.post<AuthResponse>(API_ENDPOINTS.REGISTER, variables);
  },
  registerCustomer: (variables: any) => {
    return HttpClient.post<AuthResponse>(API_ENDPOINTS.REGISTER_CUSTOMER, variables);
  },
  verifyEmailAddress: (variables: any) => {
    return HttpClient.post<any>(
      API_ENDPOINTS.VERIFY_EMAIL_ADDRESS,
      variables
    );
  },
  sendOtp: (variables: any) => {
    return HttpClient.post(API_ENDPOINTS.SEND_OTP, variables);
  },
  verifyOTP: (variables: any) => {
    return HttpClient.post<any>(
      API_ENDPOINTS.VERIFY_SEND_OTP,
      variables
    );
  },
  forgetPassword: (variables: ForgetPasswordInput) => {
    return HttpClient.post<any>(API_ENDPOINTS.FORGET_PASSWORD, variables);
  },
  verifyForgetPasswordOTP: (variables: VerifyForgetPasswordTokenInput) => {
    return HttpClient.post<any>(
      API_ENDPOINTS.VERIFY_FORGET_PASSWORD_OTP,
      variables
    );
  },
  resetPassword: (variables: ResetPasswordInput) => {
    return HttpClient.post<any>(API_ENDPOINTS.RESET_PASSWORD, variables);
  },
  // resendVerificationEmail: () => {
  //   return HttpClient.post<any>(API_ENDPOINTS.SEND_VERIFICATION_EMAIL, {});
  // },  
};
